import React from 'react'

import outreachEmptyState from './empty-state.jpeg'
import { Box, Typography } from '@material-ui/core'

export const EmptyState = () => {
  return (
    <Box
      maxWidth={800}
      margin={[0, 'auto']}
      color="textSecondary"
    >
      <Box
        maxWidth={450}
        m={[0, 'auto']}
        textAlign="center"
      >
        <Box mb={2}>
          <Typography variant="h3">Get Started with Outreach Messages to Connect with Students and Parents</Typography>
        </Box>
        <Typography
          variant="body1"
          paragraph
        >
          Create automated and one time messages to send to students and parents that are interested in your school.
        </Typography>
        <Typography
          variant="body1"
          paragraph
        >
          <a href="https://scoir.helpdocs.io/article/6fejrfngu7-outreach-messages">
            See our Help and Support Pages for more how-to information.
          </a>
        </Typography>
      </Box>
      <Box mt={3}>
        <img
          alt=""
          src={outreachEmptyState}
        />
      </Box>
    </Box>
  )
}

export default EmptyState
